import { React, useState, forwardRef, useImperativeHandle, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../Context/LanguageContext';

import DownImage from '../../image/down.png';
import UpImage from '../../image/up.png';
import InfiniteImage from '../../image/Infinite.png';

const NewMemberShipMaxCountInput = forwardRef((props, ref) => {
  const { dateVal, setDateVal, explanation, isRegularPayment, unit, isSmall } = props;
  const { t } = useLanguage();
	const [changed, setChanged] = useState(false);
  const [noLimit, setNoLimit] = useState(false);

  const InputRef = useRef();

  useImperativeHandle(ref, () => ({
		setValue: (val) => {
      if (val === -1) {
        setDateVal(0);
        setNoLimit(true);
      }
      else{
        setDateVal(val);
        setNoLimit(false);
      }
		},
		getValue: () => {
      if (noLimit) return -1;
      else return dateVal;
		},
    reset: (noLimit) => {
      setDateVal(0);
      setNoLimit(noLimit);
    }
	}))

  useEffect(() => {
    if (dateVal === -1) setNoLimit(true);
    else setNoLimit(false);
  }, [dateVal])

	function handleChange(e) {
    const regex = /[^0-9]/g;
    const result = e.target.value.replace(regex, "");
   
    if (e.target.value === '') setDateVal(0);
		else setDateVal(parseInt(result));
		setChanged(true);
	}

	function handleFocus(e) {

	}

  function upButtonClick() {
    if (noLimit) return;
    setDateVal(dateVal + 1);
  }

  function downButtonClick(){
    if (noLimit) return;
    if (dateVal > 0) setDateVal(dateVal - 1);
  }

  function onClickNoLimit() {
    if (!noLimit) setDateVal(-1);
    else setDateVal(0);
    
    setNoLimit(!noLimit);
  }
  return (
    <TopLevelWrapper>
      <ExplanationWrapper>
        <Explanation>{explanation}</Explanation>
        {
          !isRegularPayment &&
          <LimitWrapper>
            <Image width={17} height={8} src={InfiniteImage} />
            <LimitCheckBox noLimit={noLimit} onClick={onClickNoLimit} isSmall={isSmall}/>
          </LimitWrapper>
        }
      </ExplanationWrapper>
      <InputWrapper>
        <Input
          disabled={noLimit}
          ref={InputRef}
          placeholder={0}
          value={noLimit ? t('system.noLimit') : dateVal}
          onChange={handleChange}
          onFocus={handleFocus}
          isSmall={isSmall}/>
        <ButtonWrapper>
          <Button img={UpImage} onClick={upButtonClick} />
          <Button img={DownImage} onClick={downButtonClick} />
        </ButtonWrapper>
        <Text>{unit}</Text>
      </InputWrapper>
    </TopLevelWrapper>
  )
})

export default NewMemberShipMaxCountInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  
  transition: all 0.3s ease-in-out;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: #595959;

  margin: 0 0 0 0;

  &:hover {
    cursor: default;
  }
`;

const LimitWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const LimitCheckBox = styled.div`
  display: flex;
  flex-direction: row;

  width: 14px;
  height: 14px;

  border: 1px solid #DFDFDF;
  border-radius: 4px;

  background-color: ${props => props.noLimit ? `#FF8B48` : `#FFFFFF`};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;
  
  margin-top: 8px;

  width: 100%;
`;

const Input = styled.input`
  display: flex;
  flex-direction: row;

  // width: calc(46.31% - 18px);
  width: ${props => props.isSmall ? '51px' : '128px'};
  height: 30px;

  border: 1px solid #DFDFDF;
  border-radius: 8px;

  padding: 0 8px 0 8px;
  margin: 0 2px 0 0;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #000000;

  &:disabled {
    color: #FFFFFF;
    background-color: #FF8B48;
  }

  transition: all 0.3s ease-in-out;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 2px;
`;

const Button = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 30px;
  height: 30px;

  border: 1px solid #DFDFDF;
  border-radius: 8px;
  background: url(${props => props.img}) no-repeat center;
  background-color: #ECECEC;

  &:hover {
    cursor: pointer;
  }
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: #777777;

  margin: 0 0 0 auto;
`;

const Image = styled.img`
  width: ${props => props.width}px;
  height: ${props => props.height}px;

  object-fit: contain;
`;